import { AgentNavBarComponent } from '@agent/layout/nav-bar/agent-nav-bar.component';
import { StateService } from '@infra/state/state.service';
import { NgClass } from '@angular/common';
import { Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { type Event, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { type ResourcesEnvironment } from '@infra/resources/models';
import { ResourceService } from '@infra/resources/resources.service';
import { type Subscription } from 'rxjs';

@Component({
  selector: 'app-agent-component',
  templateUrl: './agent.component.html',
  imports: [AgentNavBarComponent, RouterOutlet, NgClass],
})
export class AgentComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  stateService = inject(StateService);
  private readonly resourceService = inject(ResourceService);

  showSearchPopup: boolean;
  secondaryNavBarShown: boolean;
  resources: ResourcesEnvironment;
  subscription2: Subscription;

  constructor() {
    this.showSearchPopup = false;
  }

  ngOnInit(): void {
    this.resourceService.resources.subscribe((resources: ResourcesEnvironment) => {
      this.resources = resources;
    });

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.stateService.showSearchPopup(false);
        window.scrollTo(0, 0);
      }
    });

    this.stateService.currentAssignmentDistinct$.subscribe(assignment => {
      this.secondaryNavBarShown = !!assignment;
    });

    this.subscription2 = this.stateService.showSearchPopup$.subscribe((show: boolean) => {
      this.showSearchPopup = show;
      if (this.showSearchPopup) {
        document.body.classList.add('no-scroll', 'overflow-hidden');
      } else {
        document.body.classList.remove('no-scroll', 'overflow-hidden');
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription2.unsubscribe();
  }

  mainContentClick(): void {
    this.stateService.showSearchPopup(false);
  }
}
